export const PaymentResponseCodes = {
  ApprovedSuccess: "0",
  PartialApproval: "5",
  DccRequested: "7",
  NonFinancialCard: "8",

  Declined: "20",
  ExpiredCard: "21",
  DuplicateApproved: "22",
  Duplicate: "23",
  PickUpCard: "24",
  ReferralCallIssuer: "25",

  BalanceNotAvailable: "30",
  NotDefined: "90",

  InvalidData: "101",
  InvalidAccount: "102",
  InvalidRequest: "103",
  AuthorizationFailed: "104",
  NotAuthorized: "105",
  OutOfBalance: "120",

  CommunicationError: "1001",
  HostError: "1002",
  GeneralError: "1009",

  //custom response codes
  CardTokenizationFailed: "2001"
} as const;

export type PaymentResponseCode = typeof PaymentResponseCodes[keyof typeof PaymentResponseCodes];